import React from "react";
import "./index.css";
import { BsyUtils } from "../../utils/Utils";
import { BsyConfig } from "../../global/BsyConfig";
import BsyFileUpload from "../BsyFileUpload";
import { dayjsUtils } from "../../utils/dayjsUtils";
import { getAfterSuffix } from "../../utils/getAfterSuffix";

export default function BsySystemPrint(props) {

  const MAX_SUBFORM_COLS = 7;
  const systemFields = ["creator", "createTime", "updateTime", "_id", "label"];

  const renderSystemFields = () => {
    let d = 0;
    systemFields.map((itemSys, indexSys) => {
      let field = props.header.find((item) => item.name === itemSys);
      if (!field) {
        return null;
      }
      return d++;
    });

    return (
      <div className={` print-info with-item-${d} `}>
        {systemFields.map((itemSys, index) => {
          let field = props.header.find((item) => item.name === itemSys);
          if (!field) {
            return null;
          }
          let df = field.tag || field.name;
          let val = props.data[df]
            ? props.data[df].nickname
              ? props.data[df].nickname
              : props.data[df]
            : "";

          if (["createTime", "updateTime"].includes(df)) {
            val = BsyUtils.date2Str(dayjsUtils.timeToTZ(val), "yyyy-MM-dd HH:mm:ss");
          }

          return (
            <div className="info-item">
              <span className="info-label">{field.text}</span>
              <span className="info-text">{val}</span>
            </div>
          );
        })}
      </div>
    );
  };

  const _formatData = (a, b) => {
    if (!a) return b;
    let c = (a.cellFmt && a.cellFmt.data) || a.format;
    switch (a.type) {
      case "datetime":
        c = c || "yyyy-MM-dd";
        c && b && (b = BsyUtils.date2Str(dayjsUtils.timeToTZ(b), c));
        break;
      case "address":
      case "location":
        c = c ? c : "pcda";
        b = BsyUtils.address2Str(b, c);
        break;
      case "combocheck":
      case "checkboxgroup": {
        if (BsyUtils.isArray(b) && b.length > 0) {
          return b.join(",");
        }
        break;
      }

      case "number":
      case "formula":
        c = c || "";

        let res = {};
        if (["assist_protime", "assist_outtime"].includes(a.name || a.field)) {
          res = BsyUtils.numberFormatTime(b, a);
        } else {
          res = BsyUtils.numberFormatValue(b, a);
          const afterSuffixVal = getAfterSuffix(a.afterSuffix)
          if (afterSuffixVal && res.text && !res.text.includes("%")) {
            res.text =  res.text + ' ' + afterSuffixVal;
          } 
        }

        b = res.text;
        break;
      default:
        b = BsyUtils.isNull(b) ? "" : b;
    }
    return b;
  };

  const _createDataCell = (b, c) => {
    // let d = a("<td ></td>").attr("colspan", 1);
    let d = _formatData(b, c);
    switch (b.type) {
      case "signature": {
        if (!BsyUtils.isObjectEmpty(c)) {

          const url = BsyUtils.getfiledownloadURL(c[0], {});

          return (
            <img
              src={url}
              alt={c[0].name}
              style={{
                width: 100,
                height: 60,
              }}
            />
          );
        }
        break;
      }
      case "image": {
        return (
          <>
            {(c || []).map((item, index) => {
              if (item) {
                const url = BsyUtils.getfiledownloadURL(item, {});
                return (
                  <img
                    src={url}
                    alt={item.name}
                    style={{
                      width: 64,
                    }}
                  />
                );
              }
              return "";
            })}
          </>
        );
      }
      case "upload":
        if (!BsyUtils.isObjectEmpty(c)) {
          return <BsyFileUpload enable={false} value={c} mode="print" />;
        }
        return "";
      case "textarea":
        if (d) return <pre>{d}</pre>;
        break;
      case "linkdata":
        return c?.key || "";
      case "flowdecision": {
        if (!BsyUtils.isObjectEmpty(c)) {
          return c.state;
        }
        break;
      }
      case "flowstate":
      case "flowState":
        let e = "";
        switch (c) {
          case BsyConfig().CONST.WORKFLOW.FLOWSTATE.INPROCESS:
            e = React.language("flow.state.inProcess");
            break;
          case BsyConfig().CONST.WORKFLOW.FLOWSTATE.COMPLETE:
            e = React.language("flow.node.end");
            break;
          case BsyConfig().CONST.WORKFLOW.FLOWSTATE.CLOSE:
            e = React.language("flow.state.closed");
            break;
          default:
            e = c;
        }
        return e;
      case "user":
      case "dept":
        if (c && c.hasOwnProperty("nickname") && c.nickname) {
          return BsyUtils._toDeptUser(c, "user");
        } else {
          return c;
        }
      case "usergroup":
      case "deptgroup":
        if (BsyUtils.isArray(c) && c.length > 0) {
          if (c[0] && c[0].hasOwnProperty("nickname") && c[0].nickname) {
            let d1 = [];
            BsyUtils.forEach(c, function (a1, b1) {
              d1.push(BsyUtils._toDeptUser(b1, "user"));
            });
            return d1.join(",");
          } else {
            let d1 = [];
            BsyUtils.forEach(c, function (a, b) {
              d1.push(b);
            });
            return d1.join(",");
          }
        }
        break;
      default:
        if (BsyUtils.isObjectEmpty(d)) {
          d = "";
        }
        return d;
    }
    return d;
  };
  const renderFields = (fields) => {
    return (
      <table className="print-body">
        <tr></tr>
        <tr></tr>
        {fields.map((item, index) => {
          if (item.name === "chargers") {
            let nodes = [];
            let users = [];
            (props.data[item.tag] || props.data[item.name] || []).map((item) => {
              if (nodes.indexOf(item.flowName) === -1) {
                nodes.push(item.flowName);
              }
              if (users.indexOf(item.userNickname) === -1) {
                users.push(item.userNickname);
              }
              return null;
            });

            return (
              <>
                <tr>
                  <td colSpan="1">{React.language("current.node")}</td>
                  <td colSpan="3">{nodes.join("、")}</td>
                </tr>

                <tr>
                  <td colSpan="1">{React.language("flow.charger.current")}</td>
                  <td colSpan="3">{users.join("、")}</td>
                </tr>
              </>
            );
          }

          const cell = _createDataCell(item, props.data[item.tag] || props.data[item.name]);

          return (
            <tr>
              <td colSpan="1">{item.text}</td>
              <td colSpan="3">{cell}</td>
            </tr>
          );
        })}
      </table>
    );
  };

  // 渲染子表单 一行最多七个字段
  const renderSubformItems = (field, subFields, subTitle) => {
    let val = props.data[field[0].name] || [];
    return (
      <table>
        <tr style={{ textAlign: "center" }}>
          <td colSpan={subFields.length}>{subTitle}</td>
        </tr>
        <tr>
          {subFields.map((item, index) => {
            return <td>{item.text}</td>;
          })}
        </tr>
        <>
          {val.map((itemval, index) => {
            return (
              <tr>
                {subFields.map((item) => {
                  return <td>{_createDataCell(item, itemval[item.name])}</td>;
                })}
              </tr>
            );
          })}
        </>
      </table>
    );
  };

  const renderSubform = (field) => {
    let subFieldGroups = [];
    let currentGroup = [];
    field[0].items.map((item, index) => {
      currentGroup.push(item);
      if (currentGroup.length === MAX_SUBFORM_COLS) {
        subFieldGroups.push(currentGroup);
        currentGroup = [];
      }
      return null;
    });
    subFieldGroups.push(currentGroup);
    return (
      <>
        {subFieldGroups.map((item, index) => {
          return renderSubformItems(field, item, field[0].text);
        })}
      </>
    );
  };

  const _isWidgetValid = (a) => {
    return (
      ["formula", "flowState", "chargers", "flowdecision"].indexOf(a.type) >
      -1 ||
      BsyUtils.isValueWidget(a.type) ||
      a.isJoined ||
      /_join_/.test(a.name)
    );
  };

  const groupElements = (arr) => {
    if (arr.length === 0) return [];

    const result = [];
    let currentGroup = [arr[0]];

    for (let i = 1; i < arr.length; i++) {
      if (!_isWidgetValid(arr[i])) {
        continue;
      }

      if (systemFields.includes(arr[i].name)) {
        continue;
      }


      if (arr[i].type === "subform") {
        result.push(currentGroup);
        currentGroup = [];
        result.push([arr[i]]);
        continue;
      }
      currentGroup.push(arr[i]);
    }
    if (currentGroup.length) {
      result.push(currentGroup);
    }
    return result;
  };

  const renderBody = () => {
    let bodys = groupElements(props.header);
    // console.log(bodys);

    return bodys.map((item, index) => {
      if (item.length === 0)
        return "";
      return item[0].type === "subform"
        ? renderSubform(item)
        : renderFields(item);
    });
  };

  const renderComments = () => {
    if (BsyUtils.isObjectEmpty(props.comments)) {
      return "";
    }
    return (
      <>
        <div>{React.language("form.comment")}</div>
        <table className="print-body">
          {props.comments.map((item, index) => {
            if (
              BsyUtils.isObjectEmpty(item.comment) &&
              BsyUtils.isObjectEmpty(item.signature)
            ) {
              // 没有审批意见
              return "";
            }

            const url = BsyUtils.isObjectEmpty(item.signature)
              ? ""
              : BsyUtils.getfiledownloadURL(item.signature, {});

            return (
              <tr>
                <td colSpan={1}>{item.flowName}</td>
                <td colSpan={3}>
                  <>
                    {!BsyUtils.isObjectEmpty(item.comment) ? (
                      <div>{`${item.operator}: ${item.comment
                        } (${BsyUtils.date2Str(
                          dayjsUtils.timeToTZ(item.updateTime),
                          "yyyy-MM-dd HH:mm"
                        )})`}</div>
                    ) : (
                      ""
                    )}
                  </>
                  <>
                    {url ? (
                      <img
                        src={url}
                        alt={item.signature[0].name}
                        style={{
                          width: 100,
                          height: 60,
                        }}
                      />
                    ) : (
                      ""
                    )}
                  </>
                </td>
              </tr>
            );
          })}
        </table>
      </>
    );
  };

  return (
    <div className={"bsy-system-print-pane"}>
      <div className="print-title">{props.title}</div>
      {renderSystemFields()}
      {renderBody()}
      {renderComments()}
    </div>
  );
}
